module.exports = __webpack_public_path__ + "static/img/bm.9ea3dbde.png";